import { c as _c } from "react/compiler-runtime";
import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@/app/utils/cn';
export type OptionsGroupOrientation = 'horizontal' | 'vertical';
export interface OptionsGroupProps extends HTMLAttributes<HTMLDivElement> {
  /**
   * (Optional) The class name of the options group
   */
  className?: string;
  /**
   * The orientation of the options group
   */
  orientation?: OptionsGroupOrientation;
  /**
   * The name of the options group
   */
  name: string;
  /**
   * (Optional) The role of the options group
   */
  role?: 'radiogroup' | 'group';
  /**
   * The children of the options group
   */
  children: ReactNode;
}
export const OptionsGroup = t0 => {
  const $ = _c(21);
  let children;
  let className;
  let name;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      className,
      name,
      orientation: t1,
      role: t2,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = name;
    $[4] = props;
    $[5] = t1;
    $[6] = t2;
  } else {
    children = $[1];
    className = $[2];
    name = $[3];
    props = $[4];
    t1 = $[5];
    t2 = $[6];
  }
  const orientation = t1 === undefined ? "horizontal" : t1;
  const role = t2 === undefined ? "radiogroup" : t2;
  const t3 = orientation === "horizontal";
  const t4 = orientation === "vertical";
  let t5;
  if ($[7] !== className || $[8] !== t3 || $[9] !== t4) {
    t5 = cn("flex", {
      "flex-wrap gap-x-6": t3,
      "flex-col": t4
    }, className);
    $[7] = className;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const t6 = `${name}-label`;
  let t7;
  if ($[11] !== orientation || $[12] !== role) {
    t7 = role === "radiogroup" && {
      "aria-orientation": orientation
    };
    $[11] = orientation;
    $[12] = role;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== children || $[15] !== props || $[16] !== role || $[17] !== t5 || $[18] !== t6 || $[19] !== t7) {
    t8 = <div className={t5} role={role} aria-labelledby={t6} {...t7} {...props}>{children}</div>;
    $[14] = children;
    $[15] = props;
    $[16] = role;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
};